import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/de';
import './Rebooking.css';
import { FiPhone } from "react-icons/fi";

moment.locale('de');

export default function Rebooking({ selectedLocationId }) {
    const navigate = useNavigate();

    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadRebooking = useCallback(async function loadRebooking() {
        try {
            setLoading(true);

            const { data } = await axios.get('/api/rebooking', {
                params: {
                    locationId: selectedLocationId,
                },
                withCredentials: true,
            });

            setAppointments(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [selectedLocationId]);

  useEffect(() => {
        if (!selectedLocationId) return;

        loadRebooking();
    }, [loadRebooking, selectedLocationId]);

    

    const handleAssignAppointment = (appointment) => {
        let snapshot = {};

        try {
            snapshot =
                typeof appointment.appointment_snapshot === 'string'
                    ? JSON.parse(appointment.appointment_snapshot)
                    : appointment.appointment_snapshot || {};
        } catch (err) {
            console.error(err);
        }

        navigate('/', {
            state: {
                rebookingAppointment: {
                    rebookingId: appointment.id,
                    locationId: appointment.location_id,

                    clientName: appointment.client_name,
                    phone: appointment.phone,
                    description: appointment.description,

                    originalDay: appointment.original_date,
                    originalArtistName: appointment.artist_name,

                    time: appointment.original_time || snapshot.time || '10:00',

                    duration: snapshot.duration || 60,
                    deposit: snapshot.deposit || 0,
                    minRange: snapshot.minRange || 0,
                    maxRange: snapshot.maxRange || 0,
                    tattoo_category: snapshot.tattoo_category || '',
                },
            },
        });
    };

    return (
        <div className="rebooking-page">

            <div className="rebooking-header">
                <h1>Rebooking</h1>

                <span>
                    {appointments.length} offene Termine
                </span>
            </div>

            {loading && (
                <p>Lade Rebooking...</p>
            )}

            {!loading && appointments.length === 0 && (
                <p>Keine Termine im Rebooking.</p>
            )}

            {!loading &&
                appointments.map((appointment) => (
                    <div
                        className="rebooking-card"
                        key={appointment.id}
                    >
                        <div className="rebooking-left">

                            <h2>
                                {appointment.client_name}
                            </h2>
                            {appointment.phone && (
                                <div className="rebooking-phone">
                                    <FiPhone />
                                    <span>{appointment.phone}</span>
                                </div>
                            )}

                            <div className="rebooking-info">
                                {moment(appointment.original_date).format("DD.MM.YYYY")}
                            </div>

                            <div className="rebooking-info">
                                {appointment.artist_name}
                            </div>

                            <div className="rebooking-description">
                                {appointment.description}
                            </div>

                        </div>

                        <button
                            className="rebooking-button"
                            onClick={() => handleAssignAppointment(appointment)}
                        >
                            Termin vergeben
                        </button>

                    </div>
                ))}

        </div>
    );
}